import * as React from 'react';

import { bemElement } from 'af-utils/bem.util';

import Tooltip from 'af-components/Tooltip';

import type { ReportBlockFormModel } from '../../../Shared/formModel';

interface SharedOwnProps {
	block: Nullable<ReportBlockFormModel>;
	editBlock: (reportTypeBlockId: string) => void;
	reportTypeBlockId: Nullable<string>;
}

interface DraggableBlockProps {
	removeBlock: (id: string) => void;
	draggingElementSource: Nullable<string>;
	index: number;
}

type Props = SharedOwnProps & DraggableBlockProps;

const PredefinedBlock: React.FC<Props> = (props: Props) => {
	const { block, editBlock, reportTypeBlockId } = props;

	const onRemoveBlock = React.useCallback(() => {
		const { removeBlock } = props as DraggableBlockProps;
		if (!reportTypeBlockId) {
			throw Error('Missing reportType block id');
		}
		removeBlock(reportTypeBlockId);
	}, [props, reportTypeBlockId]);

	const onEditBlock = React.useCallback(() => {
		if (!reportTypeBlockId) {
			throw Error('Missing reportType block id');
		}
		editBlock(reportTypeBlockId);
	}, [editBlock, reportTypeBlockId]);

	const labelOuterClassName = bemElement('report-block-form', 'draggable-label', { 'non-padded': true });
	const labelInnerClassName = bemElement('report-block-form', 'draggable-label', { stretched: true, predefined: true });

	return (
		<>
			<span className="icon-drag_indicator report-block-form__draggable-indicator" />
			<div className={labelOuterClassName}>
				<div className={labelInnerClassName}>
					<div>{block?.name}</div>
					<span className="icon-edit" onClick={onEditBlock} />
				</div>
			</div>
			<Tooltip message="Delete">
				<span className="icon-delete report-block-form__remove-icon" onClick={onRemoveBlock} />
			</Tooltip>
		</>
	);
};

export default React.memo(PredefinedBlock);
